import { Lightning, Log, Registry } from '@lightningjs/sdk'
import { Grid } from '@lightningjs/ui'
import GridViewModel from './grid-view-model'
import { AppData } from '@lightningjs/sdk'
import { AppSetup } from '../../app-setup'
import RowList from './row-model'
import { ItemNode } from './ItemNode'
import ThumbItem from '../../../ui-elements/item-base'
import { Helper } from '../../helper'
import { REQUEST_STATUS } from '../../enum'

export interface RowColumnGridTemplateSpec extends Lightning.Component.TemplateSpec {
  RowList: Grid
  focusRow: number
  gridViewModel: GridViewModel
}

export default class RowColumnGrid
  extends Lightning.Component<RowColumnGridTemplateSpec>
  implements Lightning.Component<RowColumnGridTemplateSpec>
{

  RowList = this.getByRef('RowList')!
  gridViewModel!: GridViewModel
  focusRow = 0
  focusItem = 0
  rowItem!: RowList
  rowListItems: any = [];
  requestInProgress: boolean = false;
  isInit = false;
  _searchKey = '';
  searchStr = ''

  static override _template(): Lightning.Component.Template<RowColumnGridTemplateSpec> {
    return {
      RowList: undefined
    }
  }

  $ItemChanged(focusItem: any, focusRow: any) {
    this.gridViewModel.changeFocus({
      focusRow: focusRow,
      foucsItem: focusItem,
    })
    //this.gridViewModel.checkAndLoadMoreRows(focusRow)
  }

  onIndexChanged(indexData: any) {
    //const resultCount = (this.searchStr === '' ? 100 : this.rowItem?.videosCount)
    this.fireAncestors("$handleChange", { curr: indexData.index, count: this.rowItem?.videosCount, str: this.rowItem?.name });
    this.focusItem = indexData.index
    this.gridViewModel.changeFocus({
      focusRow: this.focusRow,
      foucsItem: this.focusItem,
    })
    this.onRequestItems(indexData)

    // this.focusRow = indexData.index
    // this.gridViewModel.checkAndLoadMoreRows(this.focusRow)
  }

  // $handleEnter() {
  //   this.gridViewModel._dispatchEvent('selected')
  // }

  override _init() {
    if (!this.isInit) {
      this.patch({
        RowList: {
          x: 0,
          y: 0,
          w: (w: any) => w,
          h: (h: any) => h,
          spacing: 30,
          columns: (Helper.getRowStyle().rowstyle == 'flat-movie' ? 4 : 3),
          itemType: ThumbItem,
          type: Grid,
          collision:true,
          signals: { onIndexChanged: true },
          gcThreshold: 10
        }
      })
    }
    this.tag('RowList').children[0].collision=true
    this.tag('RowList').scroll = {
      after: 1, //start scrolling after 3 items
      jump: 1, //after three items jump three Items
      forward: 0.9, //unless last item: scroll forward if item bounds are after 90% of the List, or if value is above 1; scroll after f.e. 900 pixels
      backward: 0.1, //unless first item: scroll backward if item bounds are before 10% of the List, or if value is above 1; scroll before f.e. 50 pixels
    }

    //this.tag('RowList').columns = (Helper.getRowStyle().rowstyle == 'flat-movie' ? 3 : 4)
    this.tag('RowList').autoResize = true
    this.tag('RowList').scrollTransition = {
      duration: 0.5,
      timingFunction: 'ease-in-out'
    }
    if (!this.isInit) {
      this.isInit = true
      //this.loadInitialSearch(this._searchKey)
    }
  }

  set searchKey(str: string) {
    this._searchKey = str
    if (this.isInit) {
      this.loadInitialSearch(str)
    }
  }

  async onRequestItems(indexData: any) {
    const nextFocusItemIndx = indexData.index
    const nextPageToFetch = Math.ceil(nextFocusItemIndx / this.rowItem.limit)
    const items = []
    //const totalPage = (this.searchStr === '' ? (this.rowItem.totalPages / 10 - 1) : (this.rowItem.totalPages - 1))
    if (
      (nextPageToFetch <= this.rowItem.totalPages - 1  &&
        nextFocusItemIndx + 10 > indexData.dataLength &&
        this.rowItem.fetchedPageList[nextPageToFetch] == undefined)
    ) {
      this.requestInProgress = true;
      await this.rowItem.fetchMoreVideos(nextPageToFetch)
      if (this.rowItem.fetchedPageList[nextPageToFetch] == REQUEST_STATUS.FAIL) {           // If failed to fetch data for the page then return
        this.requestInProgress = false;
        this.rowItem.videosCount = this.rowItem.videos.length;
        this.rowItem.totalPages = Math.ceil(this.rowItem.videosCount / this.rowItem.limit);
        return
      }
      const st = nextPageToFetch * this.rowItem.limit
      let ed = st + this.rowItem.limit
      if (ed > this.rowItem.videosCount) {
        ed = this.rowItem.videosCount
      }
      for (let i = st; i < ed; i++) {
        const item: ItemNode | undefined = this.rowItem.videos[i]
        items.push({
          w: this.rowItem.row_item_width,
          h: this.rowItem.row_item_height,
          itemIndex: i,
          spacing: 30,
          type: ThumbItem,
          imgTexture: { img: item?.main_picture, w: this.rowItem.row_item_width, h: this.rowItem.row_item_height },
          item: item
        })
      }

      this.tag('RowList').addAt(items, this.rowItem.limit * nextPageToFetch)

      const { appState } = AppData as AppSetup
      const app = appState?.getApp()
      let savedSearchHistroyInfo = app?.navigation.getSearchHistroyInfo()
      if (!this.rowListItems || this.rowListItems.length <= 0) {
        this.rowListItems = savedSearchHistroyInfo.rowListItems
      }
      this.rowListItems = this.rowListItems.concat(items);
      this.requestInProgress = false;
    }
  }

  async loadInitialSearch(str: string) {
    //this.searchStr = str
    const { appState } = AppData as AppSetup
    const app = appState?.getApp()
    this.gridViewModel = app?.loadSearch(str)!
    await this.gridViewModel.fetchInitialRows()
    this.gridViewModel.createGridListUI()
    this.rowItem = this.gridViewModel.getRowAt(0)
    //const resultCount = (this.searchStr === '' ? 100 : this.rowItem?.videosCount)
    //this.fireAncestors("$handleChange", { curr: 0, count: resultCount, str: this.rowItem?.name });
    this.fireAncestors("$handleChange", { curr: 0, count: this.rowItem?.videosCount, str: this.rowItem?.name });
    const items: any = [];
    this.rowItem.videos.map((item: ItemNode, index) => {
      items.push({
        //w: parseInt("333"),
        //h: parseInt("500"),
        w: this.rowItem.row_item_width,
        h: this.rowItem.row_item_height,
        //margin: 20,
        spacing: 30,
        itemIndex:index,
        collision:true,
        itemType: ThumbItem,
        //type: Grid,
        imgUrl: item.main_picture,
        //imgTexture: { img: item?.main_picture, w: this.rowItem.row_item_width, h: this.rowItem.row_item_height },
        imgTexture: { img: item?.main_picture, w: this.rowItem.row_item_width, h: this.rowItem.row_item_height },
        item: item
      });
    });
    if (items && items.length > 0) {
      this.tag('RowList').reload(items)
      this.rowListItems = items;
    }
  }

  override _getFocused():
    | Lightning.Component<Lightning.Component.TemplateSpecLoose, Lightning.Component.TypeConfig>
    | null
    | undefined {
    return this.tag('RowList')
  }
  loadHistoryData = (searchHistroyInfo: any) => {
    const rowListItems = this.getHistroryItemList();//searchHistroyInfo.rowListItems;
    this.gridViewModel = searchHistroyInfo.gridViewModel;
    this.rowItem = this.gridViewModel.getRowAt(0)
    this.tag('RowList').reload(rowListItems)
    Registry.setTimeout(() => {
      let focusInfo = this.gridViewModel.getFocusInfo()
      this.tag('RowList').setIndex(focusInfo.foucsItem, {immediate:true});
      this.onIndexChanged({index:focusInfo.foucsItem})
      //this.gridViewModel.changeFocus(this.gridViewModel.getFocusInfo());
    }, 100)

  }

  _handleClick(target) {
   // console.log('RowColumnGrid _handleClick:', target)
    if(this.hasFocus()) {
      this.tag('RowList').setIndex(target.itemIndex, {immediate:true});
      this.fireAncestors('$handleEnter')
    }
  }

  _handleScroll(obj) {
    if (obj && obj.wheelDeltaY && obj.wheelDeltaY > 0) {
      this.tag('RowList').previous()
    } else {
      this.tag('RowList').next()
    }
  }


  $onThumbFocused(title: string) {
    this.fireAncestors('$updateThumbNameTitle', title)
  }

  getHistroryItemList=()=>{
    const { appState } = AppData as AppSetup
    const app = appState?.getApp()
    const gridViewModel = app?.searchGrid;
    const rowItem = gridViewModel.getRowAt(0)
    const items: any = [];
    rowItem.videos.map((item: ItemNode) => {      
      items.push({
        //w: parseInt("333"),
        //h: parseInt("500"),
        w: rowItem.row_item_width,
        h: rowItem.row_item_height,
        //margin: 20,
        spacing: 30,
        itemType: ThumbItem,
        //type: Grid,
        imgUrl: item.main_picture,
        //imgTexture: { img: item?.main_picture, w: this.rowItem.row_item_width, h: this.rowItem.row_item_height },
        imgTexture: { img: item?.main_picture, w: rowItem.row_item_width, h: rowItem.row_item_height },
        item: item
      });
    });
    return items;    
  }
}
